// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const SectionOut = zod.object({
  "audience": zod.string(),
  "body": zod.string(),
  "is_custom": zod.boolean(),
  "key": zod.string(),
  "position": zod.int(),
  "title": zod.string(),
  "updated_at": zod.iso.datetime({"offset":true})
});

export type SectionOut = zod.input<typeof SectionOut>;
export type SectionOutOutput = zod.output<typeof SectionOut>;
